import React from 'react';
import { motion } from 'framer-motion';
import './DealCard.css';

const DealCard = ({ deal, onClick, showActions, onVerifyMOU, onVerifyPayment }) => {
  const isPublic = !showActions;
  
  return (
    <motion.div
      className="deal-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -5, boxShadow: '0 20px 40px rgba(99, 102, 241, 0.3)' }}
      onClick={onClick}
    >
      <div className="deal-card-header">
        <h3>{deal.companyName}</h3>
        <div className="status-badges">
          {deal.mouNumber && (
            <span className="badge badge-primary">{deal.mouNumber}</span>
          )}
          {deal.mouVerified && (
            <span className="badge badge-success">MOU ✓</span>
          )}
          {deal.paymentVerified && (
            <span className="badge badge-success">Payment ✓</span>
          )}
        </div>
      </div>

      <div className="deal-card-body">
        {isPublic && (
          <>
            <div className="info-row">
              <span className="label">Student:</span>
              <span className="value">{deal.studentName}</span>
            </div>
            <div className="info-row">
              <span className="label">Year:</span>
              <span className="value">{deal.year}</span>
            </div>
          </>
        )}
        {!isPublic && (
          <>
            <div className="info-row">
              <span className="label">Student:</span>
              <span className="value">{deal.studentName}</span>
            </div>
            <div className="info-row">
              <span className="label">Amount:</span>
              <span className="value amount">₹{deal.amount}</span>
            </div>
          </>
        )}
      </div>

      {showActions && (
        <div className="deal-card-actions" onClick={(e) => e.stopPropagation()}>
          {!deal.mouVerified && (
            <button
              className="btn btn-primary"
              onClick={() => onVerifyMOU(deal.id)}
            >
              Verify MOU
            </button>
          )}
          {deal.mouVerified && !deal.paymentVerified && (
            <button
              className="btn btn-success"
              onClick={() => onVerifyPayment(deal.id)}
            >
              Verify Payment
            </button>
          )}
        </div>
      )}
    </motion.div>
  );
};

export default DealCard;
